// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import './assets/css/reset.css'
import 'swiper/dist/css/swiper.css'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

// Raven
// .config('https://2015b45dd5944e6a9e6db628a457e5df@sentry.io/199135')
// .addPlugin(RavenVue, Vue)
// .install()

Vue.config.productionTip = false
Vue.use(Mint)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

Vue.filter('dateTime', function (date) {
  var _date = new Date(date)
  var _now_date = new Date()
  var _str
  if (_now_date.getFullYear() + _now_date.getMonth() + _now_date.getDate() === _date.getFullYear() + _date.getMonth() + _date.getDate()) {
    _str = _date.getHours() + ':' + _date.getMinutes()
  } else {
    _str = _date.getFullYear() + '年' + _date.getMonth() + 1 + '月' + _date.getDate() + '日 ' + _date.getHours() + ':' + _date.getMinutes()
  }
  return _str
})

Vue.filter('trim', function (value) {
  return value.trim()
})

Vue.filter('money', function (price) {
  var _str_price = price + ''
  var _arr = _str_price.split('.')
  if (_arr.length === 1) {
    _str_price += '.00'
  } else {
    if (_arr[1].length === 1) {
      _str_price += '0'
    }
  }
  return _str_price
})

Vue.filter('minTime', function (second) {
  second = Number(second)
  var _min = parseInt(second / 60)
  var _s = second - (_min * 60)
  if (String(_min).length === 1) {
    _min = '0' + String(_min)
  }
  if (String(_s).length === 1) {
    _s = '0' + String(_s)
  }
  return _min + ':' + _s
})



// WEBPACK FOOTER //
// ./src/main.js